export const SHADOW_CARD = 'SHADOW_CARD';